import React from "react";
import { IoMdClose } from "react-icons/io";
import { useLanguageContext } from "../../Context/LanguageContext";
export default function InfoContainer({ setShowInfo, activeStep, label }) {
  const { localization } = useLanguageContext();
  const stepdiscreption = [
    {
      key: localization.equipmentProperty,
      value: localization.equipmentPropertydesc,
    },
    {
      key: localization.checkboxGenerateTicket,
      value: localization.checkboxGenerateTicketdesc,
    },
    {
      key: localization.equipmentAttributes,
      value: localization.equipmentAttributesdesc,
    },
    {
      key: localization.maxopenticket,
      value: localization.maxopenticketdesc,
    },
    {
      key: localization.durationbetweenTicket,
      value: localization.durationbetweenTicketdesc,
      more: true,
    },
    {
      key: localization.email,
      value: localization.emaildesc,
    },
    {
      key: localization.checkboxDate,
      value: localization.checkboxDatedesc,
    },
    {
      key: localization.checkboxDocument,
      value: localization.checkboxDocumentdesc,
    },
    {
      key: localization.checkboxPhoto,
      value: localization.checkboxPhotodesc,
    },
    {
      key: localization.checkboxUser,
      value: localization.checkboxUserdesc,
    },
  ];

  const example = [
    {
      key: localization.equipmentProperty,
      value: localization.equipmentPropertydesc,
    },
  ];
  const publicWebsite = (
    <div className="container" style={{ maxHeight: "34vh", overflow: "auto" }}>
      <div className="row">{localization.publicWebsiteHeading}</div>
      <ul className="mt-2">
        {stepdiscreption.map((item, index) => (
          <li className="mb-1">
            <span style={{ fontWeight: "bold" }}>{item.key} </span>
            {" : "}
            {item.value}
            {item.more && (
              <>
                <div className="row ml-0 mr-0">
                  -{localization.forExample} {localization.exampleDesc}
                </div>
                <div className="row">
                  <ul>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        {localization.Systemresponse + " : "}
                      </span>
                      {localization.Sendticket}
                      <span>{localization.raiseTicket}</span>
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        {localization.Systemresponse + " : "}
                      </span>
                      {localization.response1}{" "}
                      <span>{localization.createAnother}</span>
                    </li>
                    <li>
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        {localization.Systemresponse + " : "}
                      </span>
                      {localization.messageForTicket}
                    </li>
                  </ul>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
  const message = [
    localization.createEqGrpStep,
    localization.AddEquipmentStep,
    localization.addManufatureStep,
    //localization.addFunctionStep,
    localization.addMenuStep,
    localization.addAttributeStep,
    localization.addTestGrpStep,
    localization.addTestPlanStep,
    publicWebsite,
    localization.addResponsibilitiesStep,
  ];

  return (
    <div className="container-fluid p-5 bg-white w-75 infoContainer">
      <div className="row">
        <div className="col wordRap">
          <h2>{label}</h2>
        </div>
        <div className="col text-right cursorPoint">
          <IoMdClose onClick={() => setShowInfo(false)} />
        </div>
      </div>
      <div className="row pt-5">{message[activeStep]}</div>
    </div>
  );
}
